import { useLayoutEffect, useState } from 'react';

import { useGetCastRelationships } from '@pocapan/shared/domains/scene/ui/hooks/useGetCastRelationships';
import { getCastRelationshipId } from '../utils/getCastRelationshipId';
import { LOCAL_STORAGE_KEYS } from '../constants/localStorageKeys';
import saveData from '@pocapan/shared/utils/saveData';

/**
 * castRelationshipId를 반환. localStorage에 없으면 API 캐시에서 가져와 저장 후 반환.
 * 클라이언트 네비게이션 시에도 새로고침 없이 동작.
 */
export function useCastRelationshipId(): string {
  const [savedId, setSavedId] = useState(() => getCastRelationshipId());
  const { castRelationships } = useGetCastRelationships({
    perPage: 1,
    enabled: !savedId
  });

  const idFromApi = castRelationships?.[0]?.castRelationshipId ?? '';
  const effectiveId = savedId || idFromApi;

  useLayoutEffect(() => {
    if (castRelationships?.length && !savedId) {
      const newId = castRelationships[0].castRelationshipId;
      saveData(LOCAL_STORAGE_KEYS.CURRENT_CAST_RELATIONSHIP_ID, newId);
      setSavedId(newId);
    }
  }, [castRelationships, savedId]);

  return effectiveId;
}
